$giper_baza_land_rights $mol_list
	land $giper_baza_land
	rows /
		<= Add $mol_view sub /
			<= Add_key $mol_string
				hint @ \Public key
				value? <=> add_key? \
				submit? <=> add_commit? null
				enabled <= enabled false
			<= Add_commit $mol_button_minor
				click? <=> add_commit? null
				enabled <= enabled false
				sub /
					<= Add_commit_icon $mol_icon_plus
		^ gifts /
			<= Gift*0 $mol_view sub /
				<= Gift_rate* $mol_select
					hint @ \Speed
					value? <=> gift_rate*? \0
					enabled <= enabled false
					Filter null
					dictionary *
						0 \0 🦼 ~1W
						1 \1 🚲 ~3D
						2 \2 🛵 ~1D
						3 \3 🚜 ~D/2
						4 \4 🏇 ~8h
						5 \5 🚂 ~4h
						6 \6 🚛 ~2h
						7 \7 🚗 ~1h
						8 \8 🏍️ ~h/2
						9 \9 🏎️ ~5m
						A \A 🚅 ~2m
						B \B 🚁 ~m/2
						C \C 🛩️ ~2s
						D \D ✈️ ~s/2
						E \E 🚀 ~50ms
						F \F 🛸 ~1ms
				<= Gift_tier* $mol_select
					hint @ \Level
					value? <=> gift_tier*? \deny
					Filter null
					dictionary <= tier_options *
						deny @ \🛑 Deny
						read @ \👀 Read
						post @ \✍ Post
						pull @ \🥂 Pull
						rule @ \👑 Rule
					enabled <= enabled false
				<= Gift_name* $giper_baza_link_chip
					param <= link_param \link
					link <= peer_link* $giper_baza_link
					sub /
						^
						<= Gift_avatar* $mol_avatar
							id <= peer_id* \
